import React from 'react';
import DisabledInput from './components/DisabledInput';
import ProfileInformationContent from './components/ProfileInformationContent';

interface DisabledInputProps {
	email: string;
	phoneCountryCode: string;
	phoneNumber: string;
}

const ProfileCI: React.FC<DisabledInputProps> = ({
	email,
	phoneCountryCode,
	phoneNumber,
}) => {
	return (
		<div>
			<ProfileInformationContent>
				<h4>Información de contacto</h4>
				<div className="cyber-spacer small"></div>
				<DisabledInput
					inputLabel="Correo electrónico"
					inputValue={email}
				/>
				<span className="flex">
					<DisabledInput
						inputLabel="Código"
						inputValue={phoneCountryCode}
						maxWidth="100px"
					/>
					<DisabledInput
						inputLabel="Número de teléfono"
						inputValue={phoneNumber}
					/>
				</span>
			</ProfileInformationContent>
		</div>
	);
};

export default ProfileCI;
